import React from 'react';
import FormulaireMusee from '../components/FormulaireMusee';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';

function App() {
  return (
    <div className="App">
      <FormulaireMusee />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;
